/**
 * NOT_IN_COLLABORATION - 0: 非加密 && 非协作空间
 * IN_COLLABORATION - 1: 在协作空间内
 * IN_SAFE_FOLDER - 2: 在安全文件夹内
 */
export var ICollaborationFlag = /*#__PURE__*/function (ICollaborationFlag) {
  ICollaborationFlag[ICollaborationFlag["NOT_IN_COLLABORATION"] = 0] = "NOT_IN_COLLABORATION";
  ICollaborationFlag[ICollaborationFlag["IN_COLLABORATION"] = 1] = "IN_COLLABORATION";
  ICollaborationFlag[ICollaborationFlag["IN_SAFE_FOLDER"] = 2] = "IN_SAFE_FOLDER";
  return ICollaborationFlag;
}({});
//# sourceMappingURL=doc-meta-entity.interface.js.map